import { root } from './venuedecoders';
import { venue } from './venue';

export const venuedecoders = {
  ...root,
  venue,
};
